import React from 'react';
import {Link} from 'react-router';
import General from '../../modules/General';
import Button from "../../components/builder/Button";


const AppItem = ({app,image,title,item,uninstall,description,installed}) => (
	<li className="list-group-item">
			<div className="media">
				<div className="media-left" style={{verticalAlign:'middle'}}>
				<a className="avatar" style={{width:'100px'}} href="javascript:void(0)">
					<img className="img-fluid" src={image} alt="..." style={{borderRadius:0}} />
				</a>
			</div>
			<div className="media-body">
				<h4 className="media-heading">
					{title}
					{installed ? <span style={{marginLeft:'10px',fontWeight:'100',fontSize:'12px',marginRight:'0px'}}><i className="icon fa-check-circle-o" style={{color:'#52C643'}} aria-hidden="true"></i> Installed</span>:null}
				</h4>
				<small>{description}</small>
			</div>
			<div className="media-right" style={{textAlign:'right',width:'20%'}}>
				{installed ?
					<div className="btn-group" role="group">
						<button onClick={uninstall} type="button" className="btn btn-icon btn-dark"><i className="icon wb-trash" aria-hidden="true"></i></button>
						{
							item.oauth === true && item.hasOptions !== true ? null:<Link to={General.Link(`/apps/${app}`)} className="btn btn-icon btn-dark"><i className="icon wb-pencil" aria-hidden="true"></i></Link>
                        }
					</div>
				:null}
				{!installed
					?

					item.oauth === true ? <button onClick={ () => { General.requestAccessToken(`/apps/${app}/RedirectOauth`) } } className="btn btn-dark">Get started</button>:<Link to={General.Link(`/apps/${app}`)} className="btn btn-dark">Get started</Link>

					:null
				}

			</div>
		</div>
	</li>
);

export default AppItem;





// WEBPACK FOOTER //
// ./containers/apps/AppItem.js